export function isKioskModeEnabled(): boolean {
  if (typeof localStorage === 'undefined') {
    return false;
  }

  try {
    const raw = localStorage.getItem('kioskMode');
    return raw !== null && JSON.parse(raw) === true;
  } catch {
    return false;
  }
}
